import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const getAllContactFromState = ({ contacts }: any): any[] => contacts?.saved;
export const getAllContact = createSelector(getAllContactFromState, (getAllContactFromState) => getAllContactFromState);

const getAllContactMetaFromState = ({ contacts }: any): any[] => contacts?.meta;
export const getAllContactMeta = createSelector(getAllContactMetaFromState, (getAllContactMetaFromState) => getAllContactMetaFromState);

const getContactValuesByIdFromState = ({ contacts }: any, candidateId: any): any => {
    const candidateKeys = Object.keys(contacts?.unsaved);

    let saved = contacts?.saved[candidateId];
    if (candidateKeys.length == 0) return {...saved};

    let newValues: any = [];

    for (let key of Object.keys(contacts?.unsaved[candidateId])) {
        let item = contacts?.unsaved[candidateId][key];

        if (item.id) continue; 

        newValues.push({
            id: item.id,
            field_id: key,
            entity_id: candidateId,
            value: item.value
        });
    }

    let adjustedValues = saved?.values.map((value: any) => {
        if (!contacts?.unsaved[candidateId]) return value;
        if (!contacts?.unsaved[candidateId][value.field_id]) return value;

        return {
            ...value,
            value: contacts.unsaved[candidateId][value.field_id]['value']
        }
    });

    return {
        ...saved,
        values: [...newValues, ...adjustedValues]
    };
};
export const getContactValuesById = createSelector(
    getContactValuesByIdFromState,
    (getContactValuesByIdFromState) => getContactValuesByIdFromState
);

const getContactUnsavedChangesByIdFromState = ({ contacts }: any, candidateId: any): any[] => contacts?.unsaved[candidateId];
export const getContactUnsavedChangesById = createSelector(
    getContactUnsavedChangesByIdFromState,
    (getContactUnsavedChangesByIdFromState) => getContactUnsavedChangesByIdFromState
);


const getContactEntityByIdFromState = ({ contacts }: any, candidateId: any): any[] => contacts?.saved[candidateId]?.entity[0];
export const getContactEntityById = createSelector(
    getContactEntityByIdFromState,
    (getContactEntityByIdFromState) => getContactEntityByIdFromState
);

const getAllContactStatussesByIdFromState = ({ contacts }: any, candidateId: any): any[] => contacts?.saved[candidateId]?.status;
export const getAllContactStatussesById = createSelector(
    getAllContactStatussesByIdFromState,
    (getAllContactStatussesByIdFromState) => getAllContactStatussesByIdFromState
);

const getDatasets = ({contacts}: StoreState) => contacts.datasets; 
export const getContactDataset = createSelector(getDatasets, ({entities}) => entities);
export const getContactDatasetKeys = createSelector(getDatasets, ({ids}) => ids);

const getNewContactIdFromState = ({ contacts }: any): any[] => contacts?.new;
export const getNewContactId = createSelector(
    getNewContactIdFromState,
    (getNewContactIdFromState) => getNewContactIdFromState
);










const fetchRecords = ({ contacts }: StoreState) => contacts;
const byId = (_: StoreState, id) => id

export const getContactById = createSelector(
    fetchRecords,
    byId,
    ({ entities }, id) => entities?.[id]
);

export const getContactByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
)

export const getContactCreateFlowId = createSelector(
    fetchRecords,
    ({ createFlowId }) => createFlowId
)

export const isContactFetching = createSelector(
    fetchRecords,
    ({ _isFetching }) => _isFetching
);

export const isContactDatasetFetching = createSelector(
    fetchRecords,
    ({ datasets: { _isFetching } }) => _isFetching
)

export const getContactValuesByIdV2AsObject = createSelector(
    fetchRecords,
    ({ valuesByEntityIdByFieldId }) => valuesByEntityIdByFieldId
)

export const getContactValuesByIdV2 = createSelector(
    fetchRecords,
    (_, record_id) => record_id,
    ({ valuesByEntityIdByFieldId }, record_id) => valuesByEntityIdByFieldId?.[record_id]
)